import { forwardRef } from "react";
import { SearchIcon, XIcon } from "@heroicons/react/outline";

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  "aria-autocomplete"?: "list" | "none" | "inline" | "both";
  "aria-controls"?: string;
  "aria-activedescendant"?: string;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value,
      onChange,
      placeholder,
      className = "",
      disabled = false,
      onFocus,
      onBlur,
      onKeyDown,
      ...ariaProps
    },
    ref,
  ) => {
    return (
      <div className={`relative ${className}`}>
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <SearchIcon className="h-5 w-5 text-gray-400" strokeWidth={2} />
        </div>
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          className="w-full pl-10 pr-8 py-2.5 bg-white border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all disabled:opacity-50"
          {...ariaProps}
        />
        {value && (
          <button
            onClick={() => onChange("")}
            disabled={disabled}
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            type="button"
            aria-label="Clear"
          >
            <XIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" strokeWidth={2} />
          </button>
        )}
      </div>
    );
  },
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
